<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-6 mb-3">
          <b-form-group label="Nombre">
            <b-form-input
                v-model="name"
                :state="validate(name)"
            />
          </b-form-group>
        </div>
        <div class="col-md-6 mb-3">
          <RUTInput v-model="rut" :state="validate(rut)"></RUTInput>
        </div>

        <div class="col-md-6 mb-3">
          <b-form-group label="Escritura de la sociedad">
            <b-form-file
                v-model="legalDocument"
                :state="validate(legalDocument)"
                accept=".pdf"
            />
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-sm-2 align-items-center">
          <b-button
            type="submit"
            variant="outline-primary"
            :disabled="isUploading"
          >
            <b-spinner small v-show="isUploading"></b-spinner>
            Actualizar
          </b-button>
        </div>
        <div class="col-6 col-sm-10" v-show="showProgress">
          <ProgressCustom ref="progressCustom"></ProgressCustom>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import RUTInput from "@/components/shared/RUT-input.vue";
import { mapActions } from 'vuex';
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import { EventNames } from "@/plugins/enums";
import ProgressCustom from "@/components/shared/Progress-custom.vue";
export default {
  name: 'ShareholderCompanyEditForm',

  components: {
    ProgressCustom,
    AlertDismiss,
    RUTInput
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      id: this.item.id,
      name: this.item.name,
      rut: this.item.rut,
      legalDocument: null,
      documentId: null,

      isUploading: false,
      attemptedSubmit: false,
      showProgress: false
    }
  },

  methods: {
    ...mapActions(["editShareholder", "updateCompanyDocument"]),

    async onSubmit() {
      this.isUploading = true;

      // we only show progress bar when uploading a document, otherwise is distracting
      if (this.legalDocument !== null) {
        this.showProgress = true;
        await this.uploadDocument()
      }
      await this.updateForm()

      this.isUploading = false;
    },

    async updateForm() {
      this.$refs.progressCustom.progress(85, 'Actualizando información...');

      let data = {
        id: this.id,
        name: this.name,
        rut: this.rut,
      }

      if (this.legalDocument !== null && this.documentId !== null) {
        data.document = {
          route: this.documentId,
          name: this.legalDocument.name,
        }
      }

      let result = await this.editShareholder(data);

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message, 'danger');
        this.$refs.progressCustom.progress(0);
        this.showProgress = false;
        this.isUploading = false;
        this.attemptedSubmit = true;
        return;
      }

      this.$refs.progressCustom.progress(100, 'Proceso completado');
      this.$refs.alertDismiss.showAlert(
          'Datos actualizados correctamente',
          'success'
      );

      this.$eventBus.$emit(EventNames.UpdateLegalEntities);
      this.isUploading = false;
      this.attemptedSubmit = false;
      this.legalDocument = null;

      setTimeout(() => {
        this.showProgress = false;
      }, 1000);
    },

    async uploadDocument() {
      if (this.documentId) {
        this.$refs.progressCustom.progress(100, 'Usando documento existente...');
        return;
      }

      this.$refs.progressCustom.progress(5, 'Cargando documento...');

      let result = await this.updateCompanyDocument(this.legalDocument);
      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message, 'danger');
        this.$refs.progressCustom.progress(0 );
        return;
      }

      this.$refs.alertDismiss.showAlert('Documento subido correctamente', 'success');
      this.$refs.progressCustom.progress(70, 'Documento subido correctamente');

      this.documentId = result.data
    },

    validate(value) {
      if (this.attemptedSubmit && !value) {
        return false;
      }
      return null
    }
  }
}
</script>

